/**
 * Returns true if the two given arrays are equal one level deep
 */
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default <T, U>(array1: ReadonlyArray<T> = [], array2: ReadonlyArray<U> = []): boolean => {
	// @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
	if (array1 === array2) {
		return true;
	}

	// check one level deep
	// @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
	return array1.length === array2.length && array1.every((item, index) => item === array2[index]);
};
